import { apolloClient } from '../apollo';
import { EidEasyMutations } from './graphql/eid-easy.mutations';
import { EidEasyQueries } from './graphql/eid-easy.queries';
import type { EidEasyDoc } from './types/eid-easy-doc';

export class EidEasyService {
  static async prepareEidEasyDoc(): Promise<boolean> {
    const {
      data: { prepareEidEasyDoc },
    } = await apolloClient.mutate({
      mutation: EidEasyMutations.prepareEidEasyDoc,
    });
    return prepareEidEasyDoc;
  }

  static async getEidEasyDoc(): Promise<EidEasyDoc> {
    const {
      data: { getEidEasyDoc },
    } = await apolloClient.query({
      query: EidEasyQueries.getEidEasyDoc,
    });
    return getEidEasyDoc;
  }
}
